const pattern = /---uniform-setting-locale=(\w+)/;

export type LangType = 'cn' | 'en' | 'jp' | 'tw';

// eslint-disable-next-line complexity
export const getCurrentLanguage = () => {
    const [, lang] = document.cookie.match(pattern) || [];
    if (!lang) {
        const host = window.location.host || '';
        if (host.indexOf('.zhihuiya.') > -1) {
            return 'cn';
        } else if (host.indexOf('.patsnap.') > -1) {
            return 'en';
        }
    }
    return lang || 'en';
};
